import InfoLayout from "../components/InfoLayout";
import { GuideBlock } from "../components/GuideBlocks";
import ServiceHistoryRegForm from "../components/ServiceHistoryRegForm";
import usePageMeta from "../hooks/usePageMeta";
import { serviceHistoryBrandPage } from "../content/serviceHistoryBrands";
import { serviceHistoryPillarPage } from "../content/serviceHistoryCheck";
import { SERVICE_HISTORY_PATH } from "../content/serviceHistoryRoutes";

// ServiceBoss's service history landing pages. The prerendered copy
// (scripts/prerender-pages.mjs) renders the same content modules.

function PageBody({ brand, sections, faqs, formHeading, closingHeading, related }) {
  return (
    <section className="content">
      <div className="wrap prose">
        <ServiceHistoryRegForm brandKey={brand.key} heading={formHeading} />
        {sections.map((section) => (
          <div key={section.heading}>
            <h2>{section.heading}</h2>
            {section.blocks.map((block, i) => <GuideBlock block={block} key={i} />)}
          </div>
        ))}
        <div className="guide-faq">
          <h2>Common questions</h2>
          {faqs.map((faq) => (
            <div key={faq.q}><h3>{faq.q}</h3><p>{faq.a}</p></div>
          ))}
        </div>
        {related?.length > 0 && (
          <div className="guide-related">
            <h2>Related guides</h2>
            <ul>
              {related.map((guide) => <li key={guide.slug}><a href={guide.slug}>{guide.title}</a></li>)}
            </ul>
          </div>
        )}
        <ServiceHistoryRegForm brandKey={brand.key} heading={closingHeading} />
      </div>
    </section>
  );
}

export function ServiceHistoryCheckPage({ brand }) {
  const page = serviceHistoryPillarPage();
  usePageMeta({ title: page.title, description: page.description, canonical: `https://${brand.domain}${SERVICE_HISTORY_PATH}` });
  return (
    <InfoLayout brand={brand} eyebrow="Service history" title={page.h1} intro={page.lead}>
      <PageBody brand={brand} sections={page.sections} faqs={page.faqs} formHeading={page.formHeading} closingHeading={page.closingFormHeading} />
    </InfoLayout>
  );
}

export function ServiceHistoryBrandPage({ brand, slug }) {
  const page = serviceHistoryBrandPage(slug);
  usePageMeta({ title: page.title, description: page.description, canonical: `https://${brand.domain}${page.path}` });
  const related = page.guides
    .map((guideSlug) => brand.guides.find((guide) => guide.slug === `/guides/${guideSlug}`))
    .filter(Boolean);
  return (
    <InfoLayout brand={brand} eyebrow="Service history" title={page.h1} intro={page.intro}>
      <PageBody brand={brand} sections={page.sections} faqs={page.faqs} formHeading={page.formHeading} closingHeading={`Check the ${page.name} you are looking at`} related={related} />
    </InfoLayout>
  );
}
